import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import { Login } from './components/Login';
import { Layout } from './components/Layout';
import { BillingView } from './components/BillingView';
import { MembersView } from './components/MembersView';
import { modules_for } from './apps/registry';
import { Home } from './components/Home';
import { SignupPage } from './signup/SignupPage';

// The vanity signup host serves the signup surface at every path (docs/onboarding.md §2 —
// an SPA host check, deliberately NOT a Hosting redirect: those are site-wide and would
// bounce console.captomi.com/ too; test L1). Same build, two hosts.
const IS_SIGNUP_HOST = window.location.hostname === 'signup.captomi.com';

function Shell() {
  const { state } = useAuth();
  if (state.status === 'loading') {
    return <div className="muted" style={{ padding: 24 }}>Loading…</div>;
  }
  if (state.status !== 'signed_in') {
    return <Login rejected={state.status === 'rejected' ? state.reason : undefined} />;
  }

  const modules = modules_for(state.session.apps);
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="billing" element={<BillingView />} />
        {state.session.role !== 'member' && <Route path="members" element={<MembersView />} />}
        {modules.flatMap((m) =>
          m.nav.map((n) => (
            <Route key={`${m.app_code}/${n.path}`} path={`a/${m.app_code}/${n.path}`} element={n.element} />
          )),
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  // SignupPage lives OUTSIDE AuthProvider: the console's establish() auto-exchange rejects
  // unknown identities and signs them out — both wrong mid-signup (docs/onboarding.md §3).
  if (IS_SIGNUP_HOST) return <SignupPage />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signup" element={<SignupPage />} />
        <Route
          path="*"
          element={
            <AuthProvider>
              <Shell />
            </AuthProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
